import { render, staticRenderFns } from "./SunburstChart.vue?vue&type=template&id=f0ab725e&scoped=true"
import script from "./SunburstChart.vue?vue&type=script&lang=js"
export * from "./SunburstChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ab725e",
  null
  
)

export default component.exports